import { FMSType, LocationVarKey } from "@swivl-mono/types";

import { IF_ALL, IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  InputRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.HasPayBillSpotPaymentPages,
  LocationVarKey.VoicePayBillMessage,
  LocationVarKey.VoiceSendPayBillText,
  LocationVarKey.VoicePayBillTextMessage,
  LocationVarKey.VoiceForwardPayBill,
  LocationVarKey.VoicePayBillEscalateTo,
  LocationVarKey.VoicePayBillPhoneNumber,
  LocationVarKey.VoicePayBillPermissionToEscalateMessage,
  LocationVarKey.LLMAgentInstructionsMakeAPayment,
  LocationVarKey.LLMAgentInstructionsAutopay
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Pay Bill</PageHeader>
      <Section
        {...page}
        hideIf={IF_ALL([
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SiteLink),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud)
        ])}
      >
        <SwitchRow {...page} keyName={LocationVarKey.HasPayBillSpotPaymentPages} label="Use spot Payment Pages" />
        <TextRow {...page}>
          More information on spot Payment Pages can be found{" "}
          <a
            href="https://learn.tryswivl.com/migration/spot-payments"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          .
        </TextRow>
      </Section>
      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoicePayBillMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendPayBillText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendPayBillText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoicePayBillTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardPayBill} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardPayBill, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoicePayBillEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardPayBill, "1"), IS_EQUAL(LocationVarKey.VoicePayBillEscalateTo, "swivl")])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoicePayBillPhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceForwardPayBill, "1")}
        marginTop
        label=" Permission to Escalate"
        keyName={LocationVarKey.VoicePayBillPermissionToEscalateMessage}
      />

      <SectionHeader
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
        subheading="For voice agent interactions, if the tenant chooses to pay online or enroll in autopay, the agent will stay on the line to guide them through these steps."
      >
        {" "}
        Payment & Autopay Steps{" "}
      </SectionHeader>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
        keyName={LocationVarKey.LLMAgentInstructionsMakeAPayment}
        label="How to Make a Payment"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
        keyName={LocationVarKey.LLMAgentInstructionsAutopay}
        label="How to Enroll in Autopay"
      />
    </>
  );
}
